export default {

  userConfiguration: {
    "title": "Configuración usuario",
    "changePassword": "Cambiar contraseña",
    "successTitle": "Contraseña cambiada",
    "successMessage": "Contraseña cambiada correctamente",
    "errorMessage": "Error al cambiar la contraseña, por favor intentalo otra vez"
  }
}